/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-12-16 19:08:47
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-18 21:43:16
 * @FilePath: \mpc-3\features\mpc-common\src\features\QuotationSummary\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Collapse, Form, Button, Divider, Space, Upload, Message, Popover, Alert } from '@bedrock/components'
import { FileText, FileWordO, SignetFilled } from '@bedrock/icons-react';
import DescriptionsFormItem from '@mpc/common/src/components/DescriptionsFormItem'
import CollapseTablePanel from '@mpc/common/src/components/CollapseTablePanel'
import React, { useEffect, forwardRef, useImperativeHandle, useMemo } from 'react';
import TaxRateInputNumber from "@mpc/common/src/features/NewPendingQuote/TaxRate";
import QuoteFileDetail from '@mpc/common/src/features/NewPendingQuote/QuoteFileDetail';
import { currencyOptions } from "@mpc/common/src/utils/number";
import ClosingReportBtn from '#features/MPCDemand/ClosingReportTable/ClosingReportBtn';
import StatementAttachment from '@mpc/common/src/features/StatementAttachment';
import classnames from 'classnames/bind';
import { ajax } from 'utils';
import _ from 'lodash';
import styles from './index.less';
import { outsourceDemandDownloadCaseTemplate } from '#services/api';
import AuditException from '#features/AuditException';
import { bindAiReviewResultToFormItem } from '#features/MPCDemand/bindAiReviewResultToFormItem';
const cx = classnames.bind(styles);

/**
 * 报价汇总组件
 * 用于展示和编辑报价相关的汇总信息，包括报价类型、税率、币种、服务费、报价总金额等
 * 同时集成了结案报告上传、作品上传、加热助推效果上传等功能
 */
interface Props {
  detail: any;
  planInfo: any;
  onChange?: (values: any) => void;
  editType?: 'making' | 'view';
  mode?: 'default' | 'xiaohao'; // 新增 mode
  readonly?: boolean;
  // 注入外部组件，避免循环依赖
  components?: {
    UploaderMarketingWorks?: React.ComponentType<any>;
    UploadHeatingBoostWorks?: React.ComponentType<any>;
  };
}

const MAX_SIZE_LIMIT = 1024 * 1024 * 200;

const QuotationSummary = forwardRef((props: Props, ref) => {
  const { detail, planInfo, onChange, editType = 'view', mode = 'default', readonly = false, components } = props;
  const [form] = Form.useForm();
  const [formData, setFormData] = React.useState<any>({});

  const { UploaderMarketingWorks, UploadHeatingBoostWorks } = components || {};

  useImperativeHandle(ref, () => ({
    validateFields: () => {
      return form.validateFields();
    }
  }));

  const downloadTemplate = () => {
    outsourceDemandDownloadCaseTemplate().then((res: any) => {
      res?.data && window.open(res?.data);
    });
  };

  const initFormData = (isInit: boolean = false) => {
    let $total_quoted = 0;
    let $last_round_price = 0;
    let $supplier_settle_price = 0;
    detail?.demand_suppliers?.[0]?.demand_supplier_quotes?.forEach(v => {
      $total_quoted += (v?.discount_quote_price_with_tax || 0) * 100;
      $last_round_price += (v?.last_quote_price || v?.quote_price || 0) * 100;
    })
    const currency = detail?.demand_suppliers?.[0]?.demand_supplier_quotes?.[0]?.currency?.toLocaleLowerCase()
    planInfo?.cooperate_accounts?.map(v => {
      $supplier_settle_price += (v?.$supplier_settle_price?.value || 0) * 100;
    })
    const formValue = isInit ? {} : form.getFieldsValue();
    const tempData = {
      settle_report_attachs_blob_ids: detail?.settle_report_attachs,
      signed_statement_attachs: detail?.signed_statement_attachs,
      final_settle_price: detail?.demand_advertising?.final_settle_price,
      final_settle_currency: detail?.demand_advertising?.dspf_offer_currency ||detail?.demand_advertising?.final_settle_currency || 'rmb',
      remark: detail?.remark,
      ...formValue,
      ...detail?.demand_suppliers?.[0],
      currency,
      $total_quoted: {
        value: $total_quoted / 100,
        currency
      },
      $last_round_price: {
        value: $last_round_price / 100,
        currency
      },
      $supplier_settle_price: {
        value: $supplier_settle_price / 100,
        currency
      }
    }
    form.setFieldsValue(tempData);
    setFormData(tempData);
  }

  // 初始化表单数据及计算汇总金额
  useEffect(() => {
    initFormData(false);
  }, [detail, planInfo]);

  useEffect(() => {
    initFormData(true);
  }, []);

  // 计算结案报告附件是否必填
  const settleReportAttachRequired = useMemo(() => {
    const {
      structured,
      need_content_marketing_attach,
      content_marketing_case_structured_version,
      is_screenshot_done,
      structured_version
    } = detail

    let settleReportAttachRequired = true;
    if (structured && content_marketing_case_structured_version) {
      settleReportAttachRequired = !need_content_marketing_attach
      if (!is_screenshot_done) {
        // 是否全部上传截图（主平台/付费分发）为否，则要求整单结案报告必填
        settleReportAttachRequired = true
      }
    }
    // 有结案明细上传的模块才非必填
    if (structured_version >= 1) {
      settleReportAttachRequired = false;
    }
    return settleReportAttachRequired
  }, [detail])

  const isStructured = useMemo(() => {
    return detail?.structured_version >= 1;
  }, [detail]);

  const items = [
    {
      key: 'supplier_quote_price',
      label: '报价金额',
      formItemKey: 'supplier_quote_price',
      view: true,
      show: mode === 'xiaohao',
      span: 2,
      render: () => {
        const { demand_advertising = {} } = detail;
        const { dspf_offer_price, offer_currency_name } = demand_advertising;
        return <span>{dspf_offer_price ? dspf_offer_price : '待数易同步'} {offer_currency_name || ''}</span>
      }
    },
    {
      key: '$final_settle_price',
      label: '最终结算金额',
      formItemKey: '$final_settle_price',
      required: true,
      componentClass: 'currencyType',
      show: mode === 'xiaohao',
      span: 1,
      view: !!readonly,
      formItemKeyMap: {
        value: 'final_settle_price',
        currency: 'final_settle_currency',
      },
      elementProps: {
        selectDisabled: true,
      },
      ...bindAiReviewResultToFormItem('finalSettlePrice', {
        detailData: detail,
      }),
    },
    {
      key: "quote_type",
      label: "报价类型",
      formItemKey: "quote_type",
      componentClass: "radio",
      view: true,
      required: true,
      show: mode !== 'xiaohao' && isStructured,
      elementProps: {
        style: {
          marginTop: 0
        },
        options: [
          {
            name: "含税金额",
            value: 1
          },
          {
            name: "不含税金额",
            value: 0
          }
        ]
      }
    },
    {
      key: "tax_rate",
      label: "税率",
      formItemKey: "tax_rate",
      view: true,
      componentClass: "inputNumber",
      span: 1,
      required: true,
      show: mode !== 'xiaohao' && isStructured,
      render: () => {
        return <TaxRateInputNumber view />
      }
    },
    {
      key: "currency",
      label: "报价币种 ",
      formItemKey: "currency",
      view: true,
      componentClass: "select",
      required: true,
      show: mode !== 'xiaohao' && isStructured,
      span: 2,
      elementProps: {
        style: {
          width: "100%"
        },
        options: currencyOptions
      }
    },
    {
      key: "service_fee_mode",
      label: "是否收取服务费",
      formItemKey: "service_fee_mode",
      componentClass: "radio",
      view: true,
      required: true,
      show: mode !== 'xiaohao' && isStructured,
      span: formData?.service_fee_mode === 1 ? 1 : 2,
      elementProps: {
        style: {
          marginTop: 0
        },
        options: [
          {
            name: "是",
            value: 1
          },
          {
            name: "否",
            value: 0
          }
        ]
      }
    },
    {
      key: 'service_fee_rate',
      label: '服务费率',
      formItemKey: 'service_fee_rate',
      componentClass: 'inputNumber',
      view: true,
      span: 1,
      required: true,
      show: mode !== 'xiaohao' && isStructured && formData?.service_fee_mode === 1,
      render: () => {
        return <TaxRateInputNumber view />;
      },
    },
    {
      key: "$last_round_price",
      label: "报价总金额-变更前\n(含税 + 服务费)",
      formItemKey: "$last_round_price",
      componentClass: "currencyType",
      elementProps: {
        currencyColor: 'black'
      },
      required: true,
      span: 1,
      view: true,
      show: mode !== 'xiaohao' && isStructured,
    },
    {
      key: "$total_quoted",
      label: "报价总金额-变更后\n(含税 + 服务费)",
      formItemKey: "$total_quoted",
      componentClass: "currencyType",
      required: true,
      span: 1,
      view: true,
      show: mode !== 'xiaohao' && isStructured,
    },
    {
      key: 'remark',
      label: '报价变更原因',
      required: true,
      formItemKey: 'remark',
      componentClass: 'textarea',
      span: 2,
      view: true,
      show: mode !== 'xiaohao' && isStructured && !!formData?.remark,
    },
    {
      key: "merge_quote_attachs",
      label: "报价总明细",
      formItemKey: "merge_quote_attachs",
      required: false,
      span: 2,
      show: mode !== 'xiaohao' && isStructured,
      render: () => {
        return <QuoteFileDetail detail={detail} view isAll />;
      }
    },
    {
      key: "bid_attachs",
      label: "供应商比选方案及文件",
      className: "view_upload_BkvKx",
      formItemKey: "bid_attachs",
      componentClass: "upload",
      required: false,
      span: 2,
      view: true,
      show: mode !== 'xiaohao' && isStructured,
      elementProps: {
        tip: "单个文件不能超过50M",
        fileSizeLimit: 52428800
      }
    },
    {
      key: "$supplier_settle_price",
      label: "最终结算总金额(含税 + 服务费)",
      formItemKey: "$supplier_settle_price",
      componentClass: "currencyType",
      required: true,
      span: 1,
      view: true,
      show: mode !== 'xiaohao' && isStructured,
      ...bindAiReviewResultToFormItem('finalSettlePrice', {
        detailData: detail,
      }),
    },
    {
      key: "quote_settle_reports",
      label: "结案总明细",
      formItemKey: "quote_settle_reports",
      required: true,
      view: editType !== 'making' || readonly,
      span: 1,
      show: mode !== 'xiaohao' && isStructured && detail?.need_structured_settle_report,
      validateTrigger: false,
      watchChildFormValidate: true,
      render: () => {
        return <ClosingReportBtn detail={detail} view={editType !== 'making' || readonly} />;
      },
      ...bindAiReviewResultToFormItem('quoteSettleReport', {
        detailData: detail,
      }),
    },
    {
      key: 'boost',
      formItemKey: 'boost',
      label: '上传加热助推效果',
      required: true,
      span: 2,
      // 产品等于国内 并且 是喇叭体系-喇叭内容加热助推 、喇叭体系-喇叭内容传播加热-视频图文加热
      // 且注入了 UploadHeatingBoostWorks 组件时才显示
      show: !!(detail?.product_area === "DOMESTIC" && detail?.need_boost_effect_data && !!UploadHeatingBoostWorks),
      render: () => {
        return UploadHeatingBoostWorks ? (
          <UploadHeatingBoostWorks
            detail={detail}
            initBoostNum={detail?.boost_effect_data_count}
            readonly={readonly}
            onChange={(data: any) => {
              form.setFieldsValue({ boost: data });
              onChange?.(form.getFieldsValue());
            }}
          />
        ) : null;
      }
    },
    {
      key: 'upload_work',
      formItemKey: 'upload_work',
      label: '上传作品',
      required: detail?.product_area !== 'OVERSEAS',
      // 需要内容营销附件且注入了 UploaderMarketingWorks 组件时显示
      show: detail?.need_content_marketing_attach === 1 && !!UploaderMarketingWorks,
      span: 2,
      render: () => {
        return UploaderMarketingWorks ? (
          <UploaderMarketingWorks
            detail={detail}
            readonly={readonly}
            onDataChange={(data: any) => {
              form.setFieldsValue({ upload_work: data.num });
              onChange?.(form.getFieldsValue());
            }}
          />
        ) : null;
      }
    },
    {
      key: 'signed_statement_attachs',
      formItemKey: 'signed_statement_attachs',
      label: '结算单附件',
      span: 2,
      // 非内采供应商 && 结构化 && 国内 && 非费控免审 时显示
      show: !detail?.demand_suppliers?.[0]?.inner_supplier
        && detail?.structured
        && detail?.product_area === 'DOMESTIC'
        && !detail?.non_need_fee_control_verify,
      render: () => {
        return (
          <StatementAttachment
            style={{ marginTop: '5px' }}
            detail={detail}
            handleDownLoad={(value: any) => {
              form.setFieldsValue({ signed_statement_attachs: value });
              onChange?.(form.getFieldsValue());
            }}
          />
        );
      },
    },
    {
      key: 'settle_report_attachs_blob_ids',
      formItemKey: 'settle_report_attachs_blob_ids',
      label: '结案报告附件',
      required: settleReportAttachRequired,
      span: 2,
      show: true,
      view: readonly,
      componentClass: 'upload',
      elementProps: {
        tip: <>
          <span>(单个文件不超过200M)</span>
          <div style={{ marginTop: 8 }}>
               <Button type="link" icon={<FileText/>} onClick={downloadTemplate}>
                 下载模版
               </Button>
            </div>
            {
              (detail?.structured && detail?.content_marketing_case_structured_version && !detail?.is_screenshot_done) ?
                <div className={cx('making-content-upload-tip-text')}>注：主平台/付费分发作品未上传作品截图，仍需上传结案报告。</div> :
                (
                  detail?.$contentStructured && <div className={cx('making-content-upload-tip-text')}>注：本需求单中的达人合作数据，已自动获取您在内容营销系统上传的相关数据。因此，除差旅餐饮事项(如有，请在上述合作内容中上传)外，您无需提供结案报告。如有需要，您可以下载本需求的结案信息，感谢您的配合。</div>
                )
            }
        </>,
        fileSizeLimit: MAX_SIZE_LIMIT,
        beforeUpload: (file: File) => {
          if (/\.xls$/i.test(file.name)) {
            Message.error('不支持上传 .xls 格式文件，请转换为 .xlsx 格式后重新上传');
            return false;
          }
          return true;
        },
        dataParams: {
          model: 'SocialMedia::Project',
          attach_type: 'settle_report_attachs',
        },
      },
      ...bindAiReviewResultToFormItem('settleReportAttachs', {
        detailData: detail,
      }, { showGroups: true }),
    },
  ];

  return (
    <Form
      form={form}
      onValuesChange={(changeValues, values) => {
        onChange?.(values)
      }}
    >
      {
        <Collapse
          activeKey={[1]}
        >
          <CollapseTablePanel
            showArrow={false}
            key={1}
            header={<div>{isStructured ? '报价汇总' : '结案信息'}</div>}
          >
            <DescriptionsFormItem
              renderData={{
                detailData: detail,
              }}
              column={2}
              items={items as any}
            />
          </CollapseTablePanel>
        </Collapse>
      }
    </Form>
  )
})


// 提交结案按钮popover提示
export const SubmitCaseReportPopover = (props: any) => {
  const { children, showPopover = true } = props;
  if (showPopover) {
    return (
      <Popover
        getPopupContainer={() => document.body}
        showArrow={false}
        overlayClassName={cx("submit-case-report-popover-overlay")}
        // visible={true}
        content={
          <Alert
            message="提交结案后将发起审核"
            description="审核结果若有异常，将发送通知到邮箱，请及时关注处理。"
            type="info"
            showIcon
            icon={<SignetFilled />}
            className="w-[360px]"
          />
        }>
        {children}
      </Popover>
    )
  }
  return children;
}

export default QuotationSummary
